import { createFileRoute } from '@tanstack/react-router'
import { AppearanceConfig } from '~/features/webchat/components'

export const Route = createFileRoute('/workspaces/$workspaceId/bots/$botId/webchat/v2/appearance')({
  component: Component,
})

function Component() {
  const { workspaceId, botId } = Route.useParams()

  return <AppearanceConfig workspaceId={workspaceId} botId={botId} />
}
